export default {
  showActiveAlarmsOnly: 'Nur aktive Störungen anzeigen',
};
